module.exports = __webpack_public_path__ + "static/img/setup.313a113.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/setup.jpeg
// module id = TAhV
// module chunks = 0